import React from 'react';
import OurAppCard from '../cards/OurAppCard';
import BaseSection from './_shared/BaseSection';

const OurAppSection = ({ id }, ref) => {
    return (
        <BaseSection
            id={id}
            name="Our App"
            introduction=""
            iSize="section-text-default"
            iColor="text-card-title-color"
            ref={ref}
            styles="mb-10"
        >
            <OurAppCard />
        </BaseSection>
    );
};

export default React.forwardRef(OurAppSection);
